module.exports = __webpack_public_path__ + "img/icon-download.d04abcd2.svg";